import React, { FC } from 'react';
import { Col, Row } from 'react-bootstrap';
import VideoPlayer from './VideoPlayer';
import VideoSelector from './VideoSelector';
import banner1 from '../../assets/img/img_2.png';
import banner2 from '../../assets/img/img_3.png';
import enterButton from '../../assets/img/bt_ingresa.png';

const Body: FC = () => {
  return (
    <>
      <Row style={{
        marginBottom: 30
      }}>
        <Col md={8}>
          <VideoPlayer />
        </Col>
        <Col md={4}>
          <VideoSelector />
        </Col>
      </Row>
      <Row>
        <Col md={9}>
          <div
            style={{
              width: '100%',
              height: 207.54,
              borderRadius: 15,
              backgroundImage: `url(${banner1})`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            }}>
            <h1
              style={{
                fontSize: '2.25rem',
                fontWeight: 'bold',
                lineHeight: '2.81rem',
                textAlign: 'right',
                marginRight: '1.38rem',
                paddingTop: '1.38rem',
              }}>
              Aprende ingl&eacute;s con <span style={{ color: '#FF6432' }}>AMUSSE!</span>
            </h1>
            <h2
              style={{
                fontSize: '1.06rem',
                color: '#717272',
                marginRight: '1.44rem',
                textAlign: 'right',
                lineHeight: '1.88rem',
              }}>
              <span style={{ color: '#FF6432' }}>ES GRATIS!</span> Entra ya y divi&eacute;rtete aprendiendo
              <br />
              ingl&eacute;s disfrutando de videos musicales y cine!
            </h2>
          </div>
        </Col>
        <Col
          md={3}
          style={{
            backgroundImage: `url(${banner2})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'auto',
            textAlign: 'start',
            paddingTop: '7rem',
            paddingLeft: '2.4rem',
          }}>
          <a href="#">
            <img src={enterButton} alt="Ingresa" />
          </a>
        </Col>
      </Row>
    </>
  );
};

export default Body;
